import { useEffect } from 'react'
import { REVIEW_INVITE_USE_API } from '../config'
import { useReviewInviteStore } from '../store/useReviewInviteStore'

/**
 * Hydrates the store from the backend when the seam is open, and does nothing
 * at all when it is not. Called by the page so that turning
 * `REVIEW_INVITE_USE_API` on is the only change needed here once the endpoint
 * exists.
 */
export function useReviewInviteQuery() {
  const importInvite = useReviewInviteStore(s => s.importInvite)

  useEffect(() => {
    if (REVIEW_INVITE_USE_API) {
      // The GET goes here, mapped through a mapper beside the API file, exactly
      // as features/floor-plan/api does it. Intentionally absent rather than
      // stubbed: a fake request that resolves is worse than none, it makes the
      // page look wired when it is not.
    }
  }, [importInvite])

  return { isBackedByApi: REVIEW_INVITE_USE_API }
}
